/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Pick_ClientInputs */

const cs_demands_pick_client = /** @type {(inputs: Demands_Pick_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte klienta`)
};

const en_demands_pick_client = /** @type {(inputs: Demands_Pick_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a client`)
};

/**
* | output |
* | --- |
* | "Choose a client" |
*
* @param {Demands_Pick_ClientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_pick_client = /** @type {((inputs?: Demands_Pick_ClientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Pick_ClientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_pick_client(inputs)
	return cs_demands_pick_client(inputs)
});